import { ICardanoExplorerProps } from "../components/CardanoExplorer/CardanoExplorer";
import { externalRoutes } from "../pages/routes";
import { useProfileAppContext } from "../stores";
import { getEnv } from "../utils/network.utils";

export const useCardanoExplorer = ({
  hash,
  type,
}: Pick<ICardanoExplorerProps, "hash" | "type">) => {
  const {
    state: { cardanoExplorer },
  } = useProfileAppContext();
  const environment = getEnv();

  if (cardanoExplorer) {
    return `${externalRoutes.explorer[environment][cardanoExplorer]}/${type}/${hash}`;
  }

  return "";
};
